<template>
    <div class="flex items-center h-full">
        <!-- <img :src="params.data.basic_details.picture" alt=""> -->
        <img v-if="params.data.basic_details.picture != ''" style="width: 25px; height: 25px; object-fit: contain;" class="person-img rounded-full shadow-md block" :src="params.data.basic_details.picture" />
        
        <img
            v-else
            class="avatar-style"
            :src="require('@/assets/images/man-avatar.png')"
            alt=""
          />
        <strong style="width: calc(100% - 25px);" class="pl-2">{{params.data.basic_details.first_name}} {{params.data.basic_details.middle_name}} {{params.data.basic_details.last_name}}</strong>
    </div>
</template>

<script>
export default {
  name: 'FullNameCell',
  mounted () {
  }
}
</script>
<style>
.avatar-style {
  width: 30px;
  height: auto;
  border-radius: 50%;
  align-items: center;
}
</style>